import { render, staticRenderFns } from "./TypeDisplay.vue?vue&type=template&id=75d46e99&"
import script from "./TypeDisplay.vue?vue&type=script&lang=js&"
export * from "./TypeDisplay.vue?vue&type=script&lang=js&"
import style0 from "./TypeDisplay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports